import React, { useState } from 'react';
import { Tab, Nav } from 'react-bootstrap';
import CheckRow from '../CheckRow';
import { ContentTab } from './styles';

function CheckCol({ dados, onChecked, selecoes }) {
    const handleCheckboxChange = (item, isChecked, itemSelect) => {
        onChecked(item, isChecked, itemSelect);
    }

    return (
        <Tab.Container>
            <Nav variant="tabs">
                {dados.map((item) => (
                    <Nav.Item key={item.title}>
                        <Nav.Link eventKey={item.title}>
                            {item.title}
                        </Nav.Link>
                    </Nav.Item>
                ))}
            </Nav>
            <ContentTab>
                {dados.map((item) => (
                    <Tab.Pane key={item.title} eventKey={item.title}>
                        {item.subNav.length === 0 
                            ? <CheckRow dados={[item]} onChecked={handleCheckboxChange} selecoes={selecoes}/>
                            : <CheckRow dados={item.subNav} onChecked={handleCheckboxChange} selecoes={selecoes}/>
                        }
                    </Tab.Pane>
                ))}
            </ContentTab>
        </Tab.Container>
    );
}

export default CheckCol;